export default class VideosResultConfig {

  private _cutomMetaData = true;
  private _cutomMetaDataFields = new Array<string>();
  private _keywords = true;
  private _channels = true;

  public isDefault() {
    return this.cutomMetaData === true &&
      this.cutomMetaDataFields.length === 0 &&
      this.keywords === true &&
      this.channels === true;
  }

  public get cutomMetaData() {
    return this._cutomMetaData;
  }
  public set cutomMetaData(value) {
    this._cutomMetaData = value;
  }
  public get cutomMetaDataFields() {
    return this._cutomMetaDataFields;
  }
  public set cutomMetaDataFields(value) {
    this._cutomMetaDataFields = value;
  }

  public get keywords() {
    return this._keywords;
  }
  public set keywords(value) {
    this._keywords = value;
  }

  public get channels() {
    return this._channels;
  }
  public set channels(value) {
    this._channels = value;
  }

}